<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/contacto.webp">
  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">CONTACTO</h1>
    </div>
  </div>
</header>
<section id="" class="section-bg-clear">
  <div class="container">
    <div class="row mb-3 justify-content-center">
      <div class="col-xs-12 align__element-center w-100">
        <h2 class="section-title-black">Zeeker España</h2>
        <p class="font-medium">Estamos a tu disposición para a cualquier pregunta que te pueda surgir. Crearemos una
          solución
          efectiva que cubra tus necesidades.</p>
      </div>
      <!-- <iframe id="my_typeform" src="https://form.typeform.com/to/SK5FhVsv?typeform-medium=embed-snippet"
        style="width: 100%; height: 500px;"></iframe> -->
      <app-contact-form></app-contact-form>


    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="icons_standar icons_blue">
          <img src="assets/svg/map-location.svg" alt="map" class="teal-filter">
        </div>
        <h4>Visítanos</h4>
        <p class="font-medium">Calle Henri Dunant, 15-17<br>
          Madrid, 28036 España</p>
      </div>
      <div class="col-sm-4">
        <div class="icons_standar icons_blue">
          <img src="assets/svg/smartphone.svg" alt="smartphone" class="teal-filter">
        </div>
        <h4>Llámanos</h4>
        <a href="tel:+34660769358" class="font-medium">+34 660 769 358</a>
      </div>
      <div class="col-sm-4">
        <div class="icons_standar icons_blue">
          <img src="assets/svg/email.svg" alt="email" class="teal-filter">
        </div>
        <h4>Escríbenos</h4>
        <a href="mailto:admin@zeeker.es">admin&#64;zeeker.es</a>
      </div>
    </div>
  </div>
</section>
<section class="container-fluid mapa-full">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12142.74825761141!2d-3.6836701!3d40.4600627!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8241a2ea89135ce2!2sZeeker%20Solutions%20S.L.!5e0!3m2!1ses!2ses!4v1570014208400!5m2!1ses!2ses"
    frameborder="0" allowfullscreen=""></iframe>
</section>